/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */

export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const CustomerSuccessPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export const FileErrorTypename = 'com.hubspot.portals.platform.models.rpc.FileError';
export const FileErrorDiscriminant = 'FILE';
export const FileErrorDiscriminantKey = '@type';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorTypename = 'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const SpaceAccessResolverErrorTypename = 'com.hubspot.portals.platform.models.rpc.resolver.SpaceAccessResolverError';
export const SpaceAccessResolverErrorDiscriminant = 'SPACE_ACCESS_RESOLVER';
export const SpaceAccessResolverErrorDiscriminantKey = '@type';
export const SalesDocumentErrorTypename = 'com.hubspot.portals.platform.models.rpc.salesdocuments.SalesDocumentError';
export const SalesDocumentErrorDiscriminant = 'SALES_DOCUMENT';
export const SalesDocumentErrorDiscriminantKey = '@type';
export const TranslationsErrorTypename = 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const getNavigationManifestsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationManifests',
  auth: 'external',
  fingerprint: '9iQqokfmRl-tVUOxTfJWK0WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalNavigationRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getPortalNavigation',
  auth: 'external',
  fingerprint: 'Ehvf7LXXS3fPWNqc5-u1TEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNavigationMenuRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationMenu',
  auth: 'external',
  fingerprint: 'PfMy5w0PVV6d9KLG3JsbUhG6wsQEhV10',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};